import { FC, SVGProps } from "react";

const Pdf: FC<SVGProps<SVGSVGElement>> = ({ fill = "#FFFFFF", ...props }) => {
  return (
    <svg
      width="14px"
      height="15.0000004px"
      viewBox="0 0 14 15.0000004"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>Shape</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Main"
          transform="translate(-1231.000000, -123.000000)"
          fill={fill}
          fillRule="nonzero"
        >
          <path
            d="M1245,133 C1245,133.345178 1244.72748,133.625 1244.3913,133.625 L1242.56522,133.625 L1242.56522,134.875 L1243.78261,134.875 C1244.11878,134.875 1244.3913,135.154822 1244.3913,135.5 C1244.3913,135.845178 1244.11878,136.125 1243.78261,136.125 L1242.56522,136.125 L1242.56522,137.375 C1242.56522,137.720178 1242.2927,138 1241.95652,138 C1241.62035,138 1241.34783,137.720178 1241.34783,137.375 L1241.34783,133 C1241.34783,132.654822 1241.62035,132.375 1241.95652,132.375 L1244.3913,132.375 C1244.72748,132.375 1245,132.654822 1245,133 Z M1234.95652,134.5625 C1234.95652,135.770623 1234.00269,136.75 1232.82609,136.75 L1232.21739,136.75 L1232.21739,137.375 C1232.21739,137.720178 1231.94487,138 1231.6087,138 C1231.27252,138 1231,137.720178 1231,137.375 L1231,133 C1231,132.654822 1231.27252,132.375 1231.6087,132.375 L1232.82609,132.375 C1234.00269,132.375 1234.95652,133.354377 1234.95652,134.5625 Z M1233.73913,134.5625 C1233.73913,134.044733 1233.33035,133.625 1232.82609,133.625 L1232.21739,133.625 L1232.21739,135.5 L1232.82609,135.5 C1233.33035,135.5 1233.73913,135.080267 1233.73913,134.5625 Z M1240.43478,135.1875 C1240.43478,136.740801 1239.20843,138 1237.69565,138 L1236.47826,138 C1236.14209,138 1235.86957,137.720178 1235.86957,137.375 L1235.86957,133 C1235.86957,132.654822 1236.14209,132.375 1236.47826,132.375 L1237.69565,132.375 C1239.20843,132.375 1240.43478,133.6342 1240.43478,135.1875 Z M1239.21739,135.1875 C1239.21739,134.324555 1238.53609,133.625 1237.69565,133.625 L1237.08696,133.625 L1237.08696,136.75 L1237.69565,136.75 C1238.53609,136.75 1239.21739,136.050445 1239.21739,135.1875 Z M1231,129.875 L1231,124.25 C1231,123.559644 1231.54504,123 1232.21739,123 L1239.52174,123 C1239.68322,122.99987 1239.83814,123.065633 1239.95239,123.182813 L1244.21326,127.557813 C1244.32738,127.675124 1244.3913,127.83419 1244.3913,128 L1244.3913,129.875 C1244.3913,130.220178 1244.11878,130.5 1243.78261,130.5 C1243.44644,130.5 1243.17391,130.220178 1243.17391,129.875 L1243.17391,128.625 L1239.52174,128.625 C1239.18557,128.625 1238.91304,128.345178 1238.91304,128 L1238.91304,124.25 L1232.21739,124.25 L1232.21739,129.875 C1232.21739,130.220178 1231.94487,130.5 1231.6087,130.5 C1231.27252,130.5 1231,130.220178 1231,129.875 Z M1240.13043,127.375 L1242.31337,127.375 L1240.13043,125.133594 L1240.13043,127.375 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default Pdf;
